import { useCallback, useEffect, useMemo, useState } from 'react';
import { getDashboardSummaryRequest } from '../services/apiClient';

const idleStatus = { type: 'idle', message: '' };

const normalizeNumber = (value) =>
  typeof value === 'number' && !Number.isNaN(value) ? value : 0;

const mapSummaryToProgressItems = (metrics = {}) => {
  const items = [];

  Object.entries(metrics).forEach(([key, metric]) => {
    const schools = metric?.schools || metric?.data || [];
    const label = metric?.label || metric?.title || key;

    schools.forEach((school) => {
      const total =
        normalizeNumber(school.totalCards) ||
        normalizeNumber(school.totalSteps) ||
        normalizeNumber(school.total) ||
        0;
      const completed =
        normalizeNumber(school.completedCards) ||
        normalizeNumber(school.completedSteps) ||
        normalizeNumber(school.completed) ||
        0;
      const pending =
        normalizeNumber(school.pendingCards) ||
        normalizeNumber(school.pendingSteps) ||
        Math.max(total - completed, 0);
      const rate =
        normalizeNumber(school.completionRate) ||
        (total ? (completed / total) * 100 : 0);

      items.push({
        metricKey: key,
        metricLabel: label,
        schoolObjectId:
          school.schoolObjectId ||
          school.schoolId ||
          school._id ||
          `${key}-${school.schoolCode || school.schoolName || Math.random()}`,
        schoolName: school.schoolName || school.name || 'مدرسة غير معروفة',
        groupName: school.groupName || label,
        totalCards: total,
        completedCards: completed,
        pendingCards: pending,
        completionRate: rate,
        schoolCode: school.schoolCode,
      });
    });
  });

  return items;
};

export default function useDashboardSummary(token, isEnabled) {
  const [summary, setSummary] = useState(null);
  const [status, setStatus] = useState(idleStatus);

  const fetchSummary = useCallback(async () => {
    if (!token || !isEnabled) {
      setSummary(null);
      setStatus(idleStatus);
      return;
    }

    setStatus({ type: 'loading', message: 'جاري تحميل بيانات لوحة التحكم...' });
    try {
      const data = await getDashboardSummaryRequest(token);
      setSummary(data);
      setStatus({ type: 'success', message: '' });
    } catch (error) {
      setSummary(null);
      setStatus({
        type: 'error',
        message: error.message || 'تعذر تحميل بيانات لوحة التحكم.',
      });
    }
  }, [token, isEnabled]);

  useEffect(() => {
    fetchSummary();
  }, [fetchSummary]);

  const progressItems = useMemo(
    () => mapSummaryToProgressItems(summary?.metrics),
    [summary]
  );

  return {
    progress: progressItems,
    status,
    summary,
    reload: fetchSummary,
  };
}

